import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { GenericCrudAddComponent } from 'src/app/libs/components/generic-crud/generic-crud-add.component';
import { OverheadCost, TId } from 'src/app/models';

@Component({
  selector: 'app-overhead-costs-add',
  templateUrl: './overhead-costs-add.component.html',
  styleUrl: './overhead-costs-add.component.sass',
  standalone: false,
})
export class OverheadCostsAddComponent extends GenericCrudAddComponent<OverheadCost> {
  override async preFetch(): Promise<void> {
    const overheadId = this.initialFormValues?.overheadId as TId | undefined;
    if (!overheadId) {
      throw new Error('overheadId is required');
    }
    this.resource = this.api.resources.overheadCosts(overheadId);
  }

  override initFormGroup(): FormGroup {
    const overheadId = this.initialFormValues?.overheadId as TId | undefined;

    const now = new Date();
    const nowUtc = new Date(
      Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        now.getUTCHours(),
        now.getUTCMinutes(),
        now.getUTCSeconds(),
        now.getUTCMilliseconds(),
      ),
    );

    return this.fb.group({
      overheadId: [overheadId],
      cost: [null],
      date: [nowUtc],
    });
  }

  protected override async mapFormEntity(): Promise<Partial<OverheadCost>> {
    const v = this.form!.value as OverheadCost;
    return {
      overheadId: v.overheadId,
      cost: v.cost,
      date: v.date,
    };
  }

  protected override async mapEntityCreated(entity: OverheadCost): Promise<OverheadCost> {
    // Force a refresh of the parent overhead list values (currentCost/currentCostDate).
    const overheadId = entity.overheadId;
    if (overheadId) {
      try {
        await firstValueFrom(this.api.resources.overheads.get(overheadId));
      } catch {
        // best-effort; grid refresh is handled by the parent list if needed
      }
    }
    return entity;
  }
}

